import {sanitizeFilename} from '../../libs/shared/core/src/helpers/utilities/stringHelpers';
import {CellsContext} from '../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {
  ConversationActionContextFinder,
  ConversationInboxIdsFinder,
  ConversationMessageTypeFinder,
  ConversationNamespaceFinder,
  ConversationSubjectFinder,
} from './models/conversationHelpers';

/*
 * Constants & Types.
 */

export const CellsConversationsDragType = 'CELLS_CONVERSATIONS';

export interface CellsConversationsDragItem {
  type: typeof CellsConversationsDragType;
  conversationIds: ReadonlyArray<number>;
  sourceCustomViewId: number | undefined;
  cellsContext: CellsContext;
  findConversationActionContext: ConversationActionContextFinder;
  findConversationNamespace: ConversationNamespaceFinder;
  findConversationInboxIds: ConversationInboxIdsFinder;
  findConversationSubject: ConversationSubjectFinder;
  findConversationMessageType: ConversationMessageTypeFinder;
}

export function conversationEmlFileName(subject: string | undefined, id: number) {
  return `${sanitizeFilename(subject || `conversation-${id}`)}.eml`;
}
